import AbstractCommand from "../../../../../../shared/src/ranj/app/core/AbstractCommand";
import GameEvent from "../../../../../../shared/src/ranj/app/core/GameEvent";
import GameModel from "../model/GameModel";
import SaveModel from "../model/SaveModel";
import ScenarioCommandEvent from "../../ngt/scenario/controller/ScenarioCommandEvent";
import SkinKeys from "../../../../../../shared/src/ranj/app/ui/SkinKeys";
import ScenarioState from "../model/ScenarioState";


export default class StartScenarioCommand extends AbstractCommand {

    /**
     * @param {soma.EventDispatcher} dispatcher 
     * @param {SaveModel} saveModel 
     * @param {GameModel} gameModel 
     */
    constructor(dispatcher, saveModel, gameModel) {
        super(dispatcher);

        this.execute = function (event) {
            this.dispatch(ScenarioCommandEvent.INITIALIZE_SCENARIOS);

            if(gameModel.completed) {
                this.dispatch(GameEvent.COMPLETED);
                return;
            }

            const startedScenario = gameModel.scenarioStates.find(scenarioState => scenarioState.state === ScenarioState.STATE_STARTED);
            if (!!startedScenario) {
                this.dispatch(ScenarioCommandEvent.PLAY_SCENARIO, {
                    scenarioId: startedScenario.id,
                });
            } else {
                this.gotoScreen(SkinKeys.EPISODE_SELECTION_SCREEN);
            }
        };
    }
}
